import { render } from "./Suscripcion_UsuarioAud.vue?vue&type=template&id=b6a6c278"
import script from "./Suscripcion_UsuarioAud.vue?vue&type=script&lang=js"
export * from "./Suscripcion_UsuarioAud.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__